"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const template_1 = __importDefault(require("./template"));
const decorate_selector_1 = require("../utils/decorate-selector");
const configuration_1 = __importDefault(require("./configuration"));
class SolidTemplate extends template_1.default {
    getEntries(configurationFiles) {
        const entries = super.getEntries(configurationFiles);
        entries.push('/src/index.tsx', '/src/index.jsx', '/src/App.tsx', '/src/App.jsx');
        return entries;
    }
    getHTMLEntries() {
        return ['/static/index.html', '/public/index.html', '/index.html'];
    }
}
exports.default = new SolidTemplate('solid', 'Solid JS', 'https://github.com/solidjs/solid', 'solid', (0, decorate_selector_1.decorateSelector)(() => '#2596be'), {
    showOnHomePage: false,
    extraConfigurations: {
        '/.babelrc': configuration_1.default.babelrc,
        '/tsconfig.json': configuration_1.default.tsconfig,
    },
    distDir: 'dist',
    main: true,
    popular: true,
    mainFile: [
        '/src/index.tsx',
        '/src/index.jsx',
        '/src/App.tsx',
        '/src/App.jsx',
    ],
});
